import { useInfiniteQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollowers = async (
  id: string,
  limit?: number,
  search?: string,
  pageParam?: number | undefined,
) => {
  const { data: userData } = await supabase.auth.getSession()
  //

  if (!userData?.session?.user?.id) {
    return null
  }
  const from = pageParam || 0
  const to = from + (limit || 10) - 1

  let req: any = null
  if (userData?.session?.user?.id) {
    req = supabase
      .from('following_users')
      .select(`
      *,
      profile:user_profiles!user_id!inner (
        *,
        isFollowedByMe:following_users!follow_user_id (user_id)
      )
    `, { count: 'exact' })
      .eq('follow_user_id', id)
      .eq('profile.isFollowedByMe.user_id', userData?.session?.user?.id || '')
      .order('created_at', { ascending: false })
  } else {
    req = supabase
      .from('following_users')
      .select(`
        *,
        profile:user_profiles!user_id!inner (
          *,
          isFollowedByMe:following_users!follow_user_id (user_id)
        )
      `, { count: 'exact' })
      .eq('follow_user_id', id)
      .order('created_at', { ascending: false })
  }

  if (search) {
    req = req.or(
      `username.ilike.%${search}%,first_name.ilike.%${search}%,last_name.ilike.%${search}%`,
      { foreignTable: 'profile' },
    )
  }
  const { data, error } = await req.range(from, to);

  if (error) {
    throw new Error(error.message)
  }

  return data?.map((v) => ({
    ...v,
    profile: {
      ...v?.profile,
      isFollowedByMe: Boolean(v?.profile?.isFollowedByMe?.length),
    },
  }))
}

export default function useUserFollowersList(id: string, limit?: number, search?: string) {
  return useInfiniteQuery({
    queryKey: ['useUserFollowersList', id],
    queryFn: ({ pageParam }) => getFollowers(id, limit, search, pageParam),
    enabled: Boolean(id),
    staleTime: 60000,
    getPreviousPageParam: () => undefined,
    getNextPageParam: (lastPage: any, pages?: any[]) => (
      lastPage?.length
        ? (pages || []).reduce((acc, v) => (acc + (v?.length || 0)), 0)
        : undefined
    ),
  })
}
